import { action, makeAutoObservable, observable } from "mobx"

import {
  eventMerchantStatusType,
  eventStatusType,
} from "@/pages/EmailEdit/type"
import dayjs from "@/utils/dayjs"

interface notification {
  [key: string]: number | string
}
type notifications = {
  key: eventStatusType
  checked: number
  label: () => string
}[]

type MerchantNotifications = {
  key: eventMerchantStatusType
  checked: number
  label: () => string
}[]

type NotificationStoreProps = {
  emailConfig: notifications
}

interface ILanguagesList {
  code: string
  ename: string
  name: string
}

export default class NotificationStore implements NotificationStoreProps {
  @observable dataLoadedTime: number = 0
  @observable recipient_email: string = ""
  @observable recipient_name: string = ""

  @observable emailConfig: notifications = [
    {
      key: eventStatusType.ReturnRequestConfirmation,
      checked: 0,
      label: () => t("ReturnRequestConfirmation"),
    },
    {
      key: eventStatusType.ReturnRequestApproved,
      checked: 0,
      label: () => t("ReturnRequestApproved"),
    },
    {
      key: eventStatusType.ReturnRequestRejected,
      checked: 0,
      label: () => t("ReturnRequestRejected"),
    },
    {
      key: eventStatusType.RefundedToOriginalPaymentMethod,
      checked: 0,
      label: () => t("RefundedToOriginalPaymentMethod"),
    },
    {
      key: eventStatusType.RefundedToStoreCredit,
      checked: 0,
      label: () => t("RefundedToStoreCredit"),
    },
    {
      key: eventStatusType.RefundToStoreDiscount,
      checked: 0,
      label: () => t("RefundedToStoreDiscount"),
    },
    {
      key: eventStatusType.RefundedToStoreGiftCard,
      checked: 0,
      label: () => t("RefundedToStoreGiftCard"),
    },
    {
      key: eventStatusType.ExchangeOrderCreated,
      checked: 0,
      label: () => t("ExchangeOrderIsCreated"),
    },
  ]

  @observable emailMerchantConfig: MerchantNotifications = [
    {
      key: eventMerchantStatusType.ReturnRequestConfirmationMerchant,
      checked: 0,
      label: () => t("ReturnRequestConfirmation"),
    },
    {
      key: eventMerchantStatusType.TrackingNumberAddedByCustomer,
      checked: 0,
      label: () => t("TrackingNumberAddedByCustomer"),
    },
  ]
  // 邮件默认语言
  @observable defaultLanguages: string = ""
  @observable selectLanguages: string = ""
  // 邮件多语言设置列表
  @observable languagesList: ILanguagesList[] = []

  constructor() {
    // 使用这个才会在 MobX 6 上才会更新视图
    makeAutoObservable(this)
  }

  @action.bound
  setEmailConfig(key: string, v: number) {
    this.emailConfig.forEach((item) => {
      // 修改对应item的checked状态
      if (item.key === key) {
        item.checked = v
      }
    })
    this.emailMerchantConfig.forEach((item) => {
      // 修改对应item的checked状态
      if (item.key === key) {
        item.checked = v
      }
    })
  }

  @action.bound
  setConfig(data: notification) {
    this.dataLoadedTime = dayjs().unix()

    this.emailConfig.forEach((item) => {
      item.checked = data[item.key] as number
    })

    this.emailMerchantConfig.forEach((item) => {
      item.checked = data[item.key] as number
    })

    /**
     * 为什么和send email数据存放不一致
     * 后端接口要这么给数据，不得已只能这么设置属性了
     * 类型声明都搞乱了，不雅观
     */
    this.recipient_email = data.recipient_email as string
    this.recipient_name = data.recipient_name as string
  }

  @action.bound
  setSenderEmail(recipient_email: string) {
    this.recipient_email = recipient_email
  }
  @action.bound
  setSenderName(recipient_name: string) {
    this.recipient_name = recipient_name
  }
  @action.bound
  setDataLoadedTime(time: number) {
    this.dataLoadedTime = time
  }
  // 设置邮件默认语言
  @action.bound
  setDefaultLanguages(val: string) {
    this.defaultLanguages = val
  }
  @action.bound
  setSelectLanguages(val: string) {
    this.selectLanguages = val
  }
  // 邮件多语言设置列表
  @action.bound
  setLanguagesList(info) {
    this.languagesList = info
  }
}
